<template>
  <div class="noviceGuidancePur">
    <div class="guide-model" v-show="workbenchCurrentStepPur > 0">
      <div v-show="workbenchCurrentStepPur == item.val" :class="`guide-item guide-item${item.val}`" v-for="item in list" :key="item.val">
        <p v-html="item.title" style="line-height: 1.4"></p>
        <el-button @click="nextStep">{{ item.btnTxt }}</el-button>
        <div class="leadArrowDown">
          <img src="https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/leadArrowUp.png" alt="">
        </div>
      </div>
      <img v-show="workbenchCurrentStepPur == item.val" :class="`guide-img guide-img${item.val}`" v-for="item in list" :key="item.val" :src="item.img" alt="">
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  export default {
    data () {
      return {
        list: [
          {
            title: '在这里可以快速搜索复星供应商库中的供应商',
            val: 1,
            btnTxt: '下一步',
            img: 'http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/icon-oss/pur_guide_workbench_img1.png'
          },
          {
            title: '在这里查看常用业务数据</br>点击进入对应业务的详情界面',
            val: 2,
            btnTxt: '下一步',
            img: 'http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/icon-oss/pur_guide_workbench_img2.png'
          },
          {
            title: '通过自定义快捷菜单，</br>快速的到达常用功能界面或常用网站',
            val: 3,
            btnTxt: '下一步',
            img: 'http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/icon-oss/pur_guide_workbench_img3.png'
          },
          {
            title: '通过点击菜单列表开始体验吧</br>若您发现缺少某些功能，可咨询一链网客服',
            val: 4,
            btnTxt: '立即体验',
            img: 'http://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/icon-oss/pur_guide_workbench_img4.png'
          }
        ]
      }
    },
    computed: mapState([
      'KP',
      'workbenchCurrentStepPur'
    ]),
    methods: {
      nextStep () {
        let step = this.workbenchCurrentStepPur;
        step = step + 1
        if (step > this.list.length) {
          step = 0;
          this.userExperience();
          let bodyHtml = document.querySelector('body');
          bodyHtml.style.overflowY = 'auto';
        }
        this.$store.commit("changeWorkbenchStepPur", step)
      },
      userExperience () {
        this.$axios.post('/onelink.mdata.main.api/user/userExperience', {
        }).then((res) => {
          this.setToken('isExperience',0)
          Cookies.set('isExperience',0,{domain:'.onelinkplus.com',expires:10 });
        }).catch((err) => {
          console.log(err)
        })
      }
    }
  }
</script>
<style lang="stylus">
  .noviceGuidancePur{
    .guide-model{
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.75);
      position: fixed;
      z-index: 9999;
      top: 0px;
    }
    .leadArrowDown{
      position: absolute;
      top: -64px;
      left: 50%;
      transform: translate(-25%);
    }
    .guide-item {
      width: 360px;
      height: 180px;
      position: absolute;
      z-index: 1053;
      border: 1px solid #fff;
      border-radius: 50%;
      color: #fff;
      font-size: 14px;
      line-height: 24px;
      text-align: center;
      padding: 55px 20px 20px;
      .el-button{
        padding: 6px 20px;
        background: transparent;
        color: #fff;
      }
    }

    .guide-item1{
      top: 132px;
      width: 350px;
      height: 134px;
      right: 447px;
      padding: 45px 20px 20px;
    }

    .guide-item2{
      padding: 32px 20px 20px;
      left: 320px;
      top: 82px;
      width: 420px;
      height 125px;
      text-align: center;
      .leadArrowDown{
        position: absolute;
        top: 134px;
        left: 50%;
        transform: translate(-25%) rotate(90deg);
      }
    }

    .guide-item3{
      padding: 30px 20px 20px;
      left: auto;
      top: 200px;
      width: 360px;
      height: 125px;
      text-align: center;
      right: 472px;
      .leadArrowDown{
        position: absolute;
        left: auto;
        top: 33px;
        right: -97px;
        transform: rotate(40deg);
      }
    }

    .guide-item4{
      padding: 32px 20px 20px;
      left: 320px;
      top: 82px;
      width: 420px;
      height 125px;
      text-align: center;
      .leadArrowDown{
        position: absolute;
        top: 36px;
        left: -100px;
        transform: rotate(-43deg);
        img{
          transform: rotateY(180deg);
        }
      }
    }


    .guide-img{
      position: absolute;
    }
    .guide-img1{
      top: 10px;
      right: 406px;
    }
    .guide-img2{
      top: 302px;
      left: 215px;
    }
    .guide-img3{
      top: 185px;
      right: 15px;
    }
    .guide-img4{
      top: 102px;
      left: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/workBench/components/noviceGuidancePur.vue